/*
Default shape of the app config (the `GET api/system/config` payload).

XOL-446: produced by a factory for the same reason as `makeDefaultStore()` —
`main.js` used to alias this literal and then write into it (see the
`getConfig().meta[...] = ...` path), so a "reset to defaults" that cloned the
module object would clone whatever the last session left behind.

`roleGroups` was missing from this shape entirely, which is why
`SelectUsers.vue` throws when it reads `getConfig().roleGroups[...]` before
the authenticated config fetch resolves. The API returns it (see
SystemController@index), so it belongs here.
------------------------------------------------------------------------ */

export function makeDefaultConfig () {
  return {
    recentChanges: {},
    meta: {},
    categories: {},
    localities: {},
    selects: {},
    structures: {},
    roleGroups: {},
    orgGroups: {},
    orgAdmin: {},
    orgUtilities: {}
  }
}

export const defaultConfig = makeDefaultConfig()
